import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    bullet: {
        marginTop: 8
    }
} );

const ProgressBulletGroup = ( { bullets, classes } ) => {
    return (
        <React.Fragment>
            {
                bullets.map( ( bullet, index ) =>
                    <Typography key={index} color="textSecondary" className={classes.bullet}>{bullet.text}</Typography>
                )
            }
        </React.Fragment>
    );
};

ProgressBulletGroup.propTypes = {
    bullets: PropTypes.array,
    classes: PropTypes.object,
    isLoaded: PropTypes.bool,
};

export default withStyles( styles )( ProgressBulletGroup );
